import { getDeviceStateDataValueFromState } from '@/helpers/devices/stateHelper'

export const getErrorStateFromState = (state) => {
  return getDeviceStateDataValueFromState(state, 'error_state')
}

export const getAlarmsFromState = (state) => {
  return getDeviceStateDataValueFromState(state, 'alarms')
}
